import { connect } from "vuex-connect";
// import log from 'loglevel';
import { ErrorDialog } from "../../../components";

export default connect({
  stateToProps: {
    error: state => state.common.error
  },
  mutationsToProps: {
    resetError: "common/setError"
  }
})(ErrorDialog.name, ErrorDialog);
